export const AGENDA_PERMISSION_CODES = {
  VIEW_SECTION: 'AGENDA.VER_SECCION',
  DOWNLOAD_EXCEL: 'AGENDA.DESCARGAR_EXCEL',
  CREATE_APPOINTMENT: 'AGENDA.CREAR_CITA',
  MANAGE_APPOINTMENT: 'AGENDA.ADMINISTRAR_CITA',
  OUTLOOK_CONNECTION: 'AGENDA.CONEXION_OUTLOOK',
  VIEW_OTHERS_CALENDAR: 'AGENDA.VER_CALENDARIO_DE_OTROS_USUARIOS',
};
